// Angular
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// Material
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
// CRUD
import { InterceptService } from '../../../core/_base/crud/';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
// Auth
import { LoginModalComponent } from './login-modal/login-modal.component';
import {AuthService} from '../../../core/ngrx/main/auth.service';
import {StoreModule} from '@ngrx/store';
import {SessionReducer} from '../../../core/ngrx/main/session/session.reducer';
import {EffectsModule} from '@ngrx/effects';
import {SessionEffects} from '../../../core/ngrx/main/session/session.effects';
import {DeviceDetectorModule, DeviceDetectorService} from 'ngx-device-detector';
import { CodepinComponent } from './codepin/codepin.component';


const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		children: [
			{
				path: 'login',
				component: LoginComponent,
			},
			{
				path: 'mdp',
				component: ForgotPasswordComponent,
			},
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
		]
	},

];


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forChild(routes),

		//Ngrx
		StoreModule.forFeature('session', SessionReducer),
		EffectsModule.forFeature([SessionEffects]),

		// Material
		MatButtonModule,
		MatInputModule,
		MatFormFieldModule,
		MatCheckboxModule,
		MatIconModule,
		MatDialogModule,

		//Autres
		DeviceDetectorModule,

	],
	providers: [
		InterceptService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true
		},

	],
	exports: [AuthComponent],
	declarations: [
		AuthComponent,
		LoginComponent,
		ForgotPasswordComponent,
		LoginModalComponent,
		CodepinComponent
	],
	entryComponents: [LoginModalComponent]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders<AuthModule> {
		return {
			ngModule: AuthModule,
			providers: [
				AuthService,
                DeviceDetectorService
			]
		};
	}
}
